/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import { Pagination } from '@techsoftware/happay-widgets';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import history from '../../utils/history';
import Table from '../customComponent/customTable';
import TableConfig from '../../constants/tableListing/tableConfig';
import NoContent from '../customComponent/noContent';
import NoTransactions from '../../assets/images/nocontent/no_transactions.svg';
import Locales from '../../constants/locales';
import * as BillAction from '../../actions/billAction';

import BillExport from './billExpot';

const TransactionConstants = Locales.JSON.transactions;

function BillTxnList(props) {
  const [state, setState] = useState({
    currentPage: 1,
    pageSize: 10,
  });

  useEffect(() => {
    getBillTxnORBillPenalty(1, 10);
    setState({
      currentPage: 1,
      pageSize: 10,
    });
  }, [props.type]);

  const getBillTxnORBillPenalty = (pageNumber, pageSize) => {
    if (props.type === 'billTxn') {
      props.getBillTransactions({
        bill_id: props.billId,
        limit: pageSize * pageNumber,
        offset: pageSize * (pageNumber - 1),
      });
    } else if (props.type === 'billPenalty') {
      props.getBillPenalties({
        bill_id: props.billId,
        limit: pageSize * pageNumber,
        offset: pageSize * (pageNumber - 1),
      });
    }
  };

  const onCLickAction = (row, action) => {
    // Console.log("action");
  };

  const handleDownload = type => {
    const { currentPage, pageSize } = state;
    const query = {
      bill_id: props.billId,
      offset: pageSize * (currentPage - 1),
      limit: pageSize * currentPage,
      type,
    };
    props.pdfCsvExcelDownload(query);
  };

  const handlePageChange = (pageNumber, pageSize = 10) => {
    setState({
      currentPage: pageNumber,
      pageSize,
    });
    getBillTxnORBillPenalty(pageNumber, pageSize);
  };

  const config = TableConfig[props.type];

  const data =
    props.type === 'billTxn'
      ? props.billTxnList
        ? props.billTxnList.txn_details
        : []
      : props.billPenaltyList
      ? props.billPenaltyList.txn_details
      : [];
  const dataCount =
    props.type === 'billTxn'
      ? props.billTxnList
        ? props.billTxnList.count
        : 0
      : props.billPenaltyList
      ? props.billPenaltyList.count
      : 0;

  return (
    <Grid xs={24} direction="row" justify="flex-start" alignItems="flex-start">
      <Grid item xs={24} style={{ width: '100%' }}>
        <>
          {data?.length ? (
            <div
              style={{
                position: 'relative',
                float: 'right',
                bottom: '35px',
                right: '35px',
              }}
            >
              <BillExport handleClick={handleDownload} />
            </div>
          ) : null}
          <div className="bordered-container no-border-top bill-table-font">
            <div className="padding-t-20 padding-b-20 padding-l-30 padding-r-30">
              <Pagination
                currentPage={state.currentPage}
                totalDataSize={dataCount || 0}
                sizePerPage={state.pageSize}
                onPageChange={handlePageChange}
              />
            </div>
            <Table
              headerElements={config.header}
              data={data || []}
              shimmerRow={10}
              shimmerColumn={4}
              isDataFetched={!props.showShimmer}
              customTableOuterStyle={{ height: '600px' }}
              onClickAction={onCLickAction}
              actions={config.actions}
              colId={config.col_option}
              isActionCol={false}
              noContent={
                <NoContent
                  message={TransactionConstants.NO_TRANSACTIONS}
                  icon={NoTransactions}
                  containerHeight="500px"
                  placement="center"
                />
              }
            />
          </div>
        </>
      </Grid>
    </Grid>
  );
}
BillTxnList.propTypes = {
  billId: PropTypes.string,
  getBillTransactions: PropTypes.func,
  // showShimmer: PropTypes.bool,
  billTxnList: PropTypes.object,
  type: PropTypes.string,
  getBillPenalties: PropTypes.func,
  billPenaltyList: PropTypes.object,
  pdfCsvExcelDownload: PropTypes.func,
  showShimmer: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    ...state.router,
    ...state.Bill,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BillAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BillTxnList);
